import { useEffect, useState } from 'react';
import { API, Endpoints } from '@brg/api';
export var useGetCard = function (cardId, disabled) {
    var _a = useState(undefined), card = _a[0], setCard = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!disabled && cardId) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetCard')
                .addQuery('id', cardId)
                .addQuery('isAppNameHeaderIgnored', true)
                .get()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                setIsLoading(false);
                setCard(r);
            })
                .catch(function (e) {
                setIsLoading(false);
                setError(true);
            });
        }
    }, [cardId, disabled]);
    return { card: card, isLoading: isLoading, error: error };
};
//# sourceMappingURL=useGetCard.js.mapimport { useEffect, useState } from 'react';
import { API, Endpoints } from '@brg/api';
export var useGetCard = function (cardId, disabled) {
    var _a = useState(undefined), card = _a[0], setCard = _a[1];
    var _b = useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = useState(false), error = _c[0], setError = _c[1];
    useEffect(function () {
        if (!disabled && cardId) {
            setIsLoading(true);
            API.request()
                .endpoint(Endpoints.cardsMnePw)
                .url('/api/Card/GetCard')
                .addQuery('id', cardId)
                .addQuery('isAppNameHeaderIgnored', true)
                .get()
                .send()
                .then(function (r) { return r.json(); })
                .then(function (r) {
                setIsLoading(false);
                setCard(r);
            })
                .catch(function (e) {
                setIsLoading(false);
                setError(true);
            });
        }
    }, [cardId, disabled]);
    return { card: card, isLoading: isLoading, error: error };
};
//# sourceMappingURL=useGetCard.js.map